/**
 * 门店查询选项（报表跨租户查询）全局状态：
 * loginTenantId —— 设置目标门店时的登录租户ID（防止账号切换后残留）
 * targetTenant  —— 当前选择的目标门店租户ID（'' = 本店，不携带目标头）
 */
const storeTenant = {
  state: {
    loginTenantId: null,
    targetTenant: ''
  },
  mutations: {
    SET_STORE_TENANT (state, { loginTenantId, targetTenant }) {
      state.loginTenantId = (loginTenantId === undefined || loginTenantId === null) ? null : String(loginTenantId)
      state.targetTenant = targetTenant ? String(targetTenant) : ''
    },
    CLEAR_STORE_TENANT (state) {
      state.loginTenantId = null
      state.targetTenant = ''
    }
  }
}

export default storeTenant
